<script>
import { mapActions } from 'vuex'
import queryString from 'query-string'
import * as cookie from '@/api/cookie'

export default {
  created() {
    this.init()
  },
  methods: {
    ...mapActions({
      createAuth: 'auth/createAuth',
    }),
    init() {
      const id = this.getIdFromParams()
      const token = this.getTokenFromCookies()
      this.createAuth({ id, token })
    },
    getIdFromParams() {
      const queries = queryString.parse(location.search)
      if (queries.id) {
        this.$router.replace(this.$route.path)
      }
      return queries.id || ''
    },
    getTokenFromCookies() {
      return cookie.readToken()
    },
  },
  render(h) {
    return h() // avoid empty template warning message
  },
}
</script>
